// React imports.
import React, { Component } from "react";

// App imports.


import { Assessment4StepsEnum } from "../state";
import Assessment4DownloadCSV from "./Assessment4DownloadCSV";

const Assessment4 = ({ state }) => (
    <div>

        {state.CurrentAssessementStepIndex == Assessment4StepsEnum.checkAcctNum &&
            <div>
                <p><strong><u>Question 1:</u>Checking Routines for Household Account Numbers</strong></p>
                <ol start={1}>
                    <li>
                      Do you have a check in place for tracking the percentage of your assisted households that have a main heating
                      vendor and account number listed in their file? 
                      <br/>
                      <label>
                          <input type="radio"
                              name="checkAcctNumFlag"
                              id="checkAcctNumFlag_true"
                              value="true"
                              checked={state.Assessment4Model.checkAcctNumFlag === true}
                              onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent)}
                          />
                          <span>Yes</span>
                      </label>
                      &nbsp;&nbsp;
                      <label>
                          <input type="radio"
                              name="checkAcctNumFlag"
                              id="checkAcctNumFlag_false"
                              value="false"
                              checked={state.Assessment4Model.checkAcctNumFlag === false}
                              onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent)}
                          />
                          <span>No</span>
                      </label>
                      <br/ >
                      {state.Assessment4Model.checkAcctNumFlag === true
                        && <span><strong>Good!</strong>
                            This will help you assess which vendors should be selected for data collection.
                            It will also help you track what percentage of the total households
                            a vendor serves were provided when they deliver the data each year. 

                        </span>}
                      {state.Assessment4Model.checkAcctNumFlag === false
                        && <span>
                              <strong>Requires followup.</strong>&nbsp;
                              Accurate vendor names and account numbers are not only required for Performance Measures data collection,
                              but also for ensuring that the correct customer account is credited with the LIHEAP grant.
                              It is a “best practice” to ask vendors to report back to the grantee when the vendor
                              account number is not correct for a client, and to ensure that the client database
                              is updated with the revised account number. [Note: Some clients only apply for
                              summer cooling benefits. However, heating fuel vendors and account numbers should
                              be collected for those households so that there is a complete record of the client’s
                              energy expenditures.]
                              <br/><br/>
                              Please discuss your plan to address this issue in the response box below.

                              <textarea  name="checkAcctNumDesc"
                                    id="checkAcctNumDesc" style={{width:"100%"}}
                                    value={state.Assessment4Model.checkAcctNumDesc}
                                    onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent)}></textarea>
                              <br/>
                          </span>}
                      <br/>  
                  </li>
                </ol>
            </div>
        }

        {state.CurrentAssessementStepIndex == Assessment4StepsEnum.checkVendorCantFindAcct &&
            <div>
                <p><strong><u>Question 2:</u>Checking Routines for Missing Information in the Vendor System</strong></p>
                <ol start={2}>
                    <li>
                      Do you have a check in place for tracking the percentage of your assisted households for whom vendors cannot find accounts in the vendor system?
                      <br/>
                      <label>
                          <input type="radio"
                              name="checkVendorCantFindAcctFlag"
                              id="checkVendorCantFindAcctFlag_true"
                              value="true"
                              checked={state.Assessment4Model.checkVendorCantFindAcctFlag === true}
                              onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent)}
                          />
                          <span>Yes</span>
                      </label>
                      &nbsp;&nbsp;
                      <label>
                          <input type="radio"
                              name="checkVendorCantFindAcctFlag"
                              id="checkVendorCantFindAcctFlag_false"
                              value="false"
                              checked={state.Assessment4Model.checkVendorCantFindAcctFlag === false}
                              onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent)}
                          />
                          <span>No</span>
                      </label>
                      <br/ >
                      {state.Assessment4Model.checkVendorCantFindAcctFlag === true
                        && <span><strong>Good!</strong>
                            This will help you assess which households are missing account information and will also help you recognize whether this issue is prevalent among just one vendor, or is related to a larger issue, such as a faulty vendor system or client application. 
                        </span>}
                      {state.Assessment4Model.checkVendorCantFindAcctFlag === false
                        && <span>
                              <strong>Requires followup.</strong>&nbsp;
                              Tracking the percentage of households for whom vendors cannot find account information in the vendor system is critical to identifying the households for whom this is an issue. Tracking these statistics will also help you identify whether the issue is prevalent among just one vendor, or is related to a larger issue, such as a problem with your client application or vendor system. 
                              <br/><br/>
                              Please discuss your plan to address this issue in the response box below.

                              <textarea  name="checkVendorCantFindAcctDesc"
                                    id="checkVendorCantFindAcctDesc" style={{width:"100%"}}
                                    value={state.Assessment4Model.checkVendorCantFindAcctDesc}
                                    onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent)}></textarea>
                              <br/>
                          </span>}
                      <br/>  
                  </li>
                </ol>
            </div>
        }

        {state.CurrentAssessementStepIndex == Assessment4StepsEnum.checkShareHHDataReceivedEachVendor &&
            <div>
                <p><strong><u>Question 3:</u>Checking Percentage of Households with Data Received</strong></p>
                <ol start={3}>
                    <li>
                      Do you have a check in place for tracking the share of households for whom data were received from each vendor?

                      <br/>
                      <label>
                          <input type="radio"
                              name="checkShareHHDataReceivedEachVendorFlag"
                              id="checkShareHHDataReceivedEachVendorFlag_true"
                              value="true"
                              checked={state.Assessment4Model.checkShareHHDataReceivedEachVendorFlag === true}
                              onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent)}
                          />
                          <span>Yes</span>
                      </label>
                      &nbsp;&nbsp;
                      <label>
                          <input type="radio"
                              name="checkShareHHDataReceivedEachVendorFlag"
                              id="checkShareHHDataReceivedEachVendorFlag_false"
                              value="false"
                              checked={state.Assessment4Model.checkShareHHDataReceivedEachVendorFlag === false}
                              onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent)}
                          />
                          <span>No</span>
                      </label>
                      <br/ >
                      {state.Assessment4Model.checkShareHHDataReceivedEachVendorFlag === true
                        && <span><strong>Good!</strong>
                            This will help you assess whether you are collecting data for enough households to be representative of the entire population of assisted households with each fuel type. Vendors that supplying data should be able to furnish complete records for at least 75% of the LIHEAP households that they serve.
                        </span>}
                      {state.Assessment4Model.checkShareHHDataReceivedEachVendorFlag === false
                        && <span>
                              <strong>Requires followup.</strong>&nbsp;
                              Tracking the percentage of households for whom vendors provided data is critical for ensuring data reliability. To ensure you are receiving data from an average of 50% of your assisted households, you should be expecting each vendor to furnish data for 75% of their cases. However, if one vendor is supplying data for 90% and another is only supplying data for 30%, it would suggest that there is something wrong with how you are working with the second vendor.
                              <br/><br/>
                              Please discuss your plan to address this issue in the response box below.

                              <textarea  name="checkShareHHDataReceivedEachVendorDesc"
                                    id="checkShareHHDataReceivedEachVendorDesc" style={{width:"100%"}}
                                    value={state.Assessment4Model.checkShareHHDataReceivedEachVendorDesc}
                                    onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent)}></textarea>
                              <br/>
                          </span>}
                      <br/>  
                  </li>
                </ol>
            </div>
        }

        {state.CurrentAssessementStepIndex == Assessment4StepsEnum.checkAvgHeatExpendVsSedsPerVendor &&
            <div>
                <p><strong><u>Question 4:</u>Checking Data Against the SEDS</strong></p>
                <ol start={4}>
                    <li>
                      For each vendor, do you examine the average heating expenditures against the estimated average expenditures from the SEDS? 

                      <br/>
                      <label>
                          <input type="radio"
                              name="checkAvgHeatExpendVsSedsPerVendorFlag"
                              id="checkAvgHeatExpendVsSedsPerVendorFlag_true"
                              value="true"
                              checked={state.Assessment4Model.checkAvgHeatExpendVsSedsPerVendorFlag === true}
                              onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent)}
                          />
                          <span>Yes</span>
                      </label>
                      &nbsp;&nbsp;
                      <label>
                          <input type="radio"
                              name="checkAvgHeatExpendVsSedsPerVendorFlag"
                              id="checkAvgHeatExpendVsSedsPerVendorFlag_false"
                              value="false"
                              checked={state.Assessment4Model.checkAvgHeatExpendVsSedsPerVendorFlag === false}
                              onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent)}
                          />
                          <span>No</span>
                      </label>
                      <br/ >
                      {state.Assessment4Model.checkAvgHeatExpendVsSedsPerVendorFlag === true
                        && <span><strong>Good!</strong>
                            The SEDS generally provide a good estimate of the average main heating expenditures by fuel type for households in each state. By checking your numbers against the SEDS, you can preemptively recognize values in your data that are much higher (2x the SEDS average) or lower (1/2 the SEDS average) than what we might expect.

                        </span>}
                      {state.Assessment4Model.checkAvgHeatExpendVsSedsPerVendorFlag === false
                        && <span>
                              <strong>Requires followup.</strong>&nbsp;
                              The SEDS generally provide a good estimate of the average main heating expenditures by fuel type for households in each state. While there is some variation in the average prices charge by vendors and some parts of the state might be colder or warmer, all of your vendors should have an average expenditure that is close to the SEDS average. If one vendor is an “outlier” and has much higher average expenditures (2X the average) or has much lower average expenditures (1/2 the average), it is likely that they are reporting something incorrectly.
                              <br/><br/>
                              Please discuss your plan to address this issue in the response box below.

                              <textarea  name="checkAvgHeatExpendVsSedsPerVendorDesc"
                                    id="checkAvgHeatExpendVsSedsPerVendorDesc" style={{width:"100%"}}
                                    value={state.Assessment4Model.checkAvgHeatExpendVsSedsPerVendorDesc}
                                    onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent)}></textarea>
                              <br/>
                          </span>}
                      <br/>  
                  </li>
                </ol>
            </div>
        }

        {state.CurrentAssessementStepIndex == Assessment4StepsEnum.checkRangeReptByVendors &&
            <div>
                <p><strong><u>Question 5:</u>Checking for Outliers</strong></p>
                <ol start={5}>
                    <li>
                      Do you check the range of main heating fuel bills reported by vendors? Do you investigate the high and low outliers? 
                      <br/>
                      <label>
                          <input type="radio"
                              name="checkRangeReptByVendorsFlag"
                              id="checkRangeReptByVendorsFlag_true"
                              value="true"
                              checked={state.Assessment4Model.checkRangeReptByVendorsFlag === true}
                              onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent)}
                          />
                          <span>Yes</span>
                      </label>
                      &nbsp;&nbsp;
                      <label>
                          <input type="radio"
                              name="checkRangeReptByVendorsFlag"
                              id="checkRangeReptByVendorsFlag_false"
                              value="false"
                              checked={state.Assessment4Model.checkRangeReptByVendorsFlag === false}
                              onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent)}
                          />
                          <span>No</span>
                      </label>
                      <br/ >
                      {state.Assessment4Model.checkRangeReptByVendorsFlag === true
                        && <span><strong>Good!</strong>
                            Checking the range of your data and working with vendors to address outliers will help you improve the quality of your data. 
                        </span>}
                      {state.Assessment4Model.checkRangeReptByVendorsFlag === false
                        && <span>
                              <strong>Requires followup.</strong>&nbsp;
                              Checking the range of your customer bills and working with vendors to address outliers can improve the quality of your data. If you find some clients with very high values, the vendor may have picked the wrong account or may be including nonresidential uses such as a farm or a store in the same building. If you find some clients with very low values, the vendor may have failed to report on the charges from alternative suppliers or may be reporting on a “secondary” account held by the client.
                              <br/><br/>
                              Please discuss your plan to address this issue in the response box below.

                              <textarea  name="checkRangeReptByVendorsDesc"
                                    id="checkRangeReptByVendorsDesc" style={{width:"100%"}}
                                    value={state.Assessment4Model.checkRangeReptByVendorsDesc}
                                    onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent)}></textarea>
                              <br/>
                          </span>}
                      <br/>  
                  </li>
                </ol>
            </div>
        }

        {state.CurrentAssessementStepIndex == Assessment4StepsEnum.procsForReviewingResults &&
            <div>
                <p><strong><u>Question 6:</u>Taking Action in the Event of Failed Checks</strong></p>
                <ol start={6}>
                    <li>
                      We have just reviewed the checks you have in place, but you should ask yourself: Are there procedures in place for reviewing and resolving the findings from each check? 
                      <br/>
                      <label>
                          <input type="radio"
                              name="procsForReviewingResultsFlag"
                              id="procsForReviewingResultsFlag_true"
                              value="true"
                              checked={state.Assessment4Model.procsForReviewingResultsFlag === true}
                              onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent)}
                          />
                          <span>Yes</span>
                      </label>
                      &nbsp;&nbsp;
                      <label>
                          <input type="radio"
                              name="procsForReviewingResultsFlag"
                              id="procsForReviewingResultsFlag_false"
                              value="false"
                              checked={state.Assessment4Model.procsForReviewingResultsFlag === false}
                              onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent)}
                          />
                          <span>No</span>
                      </label>
                      <br/ >
                      {state.Assessment4Model.procsForReviewingResultsFlag === true
                        && <span><strong>Good!</strong>
                            No action needed!

                        </span>}
                      {state.Assessment4Model.procsForReviewingResultsFlag === false
                        && <span>
                              <strong>Requires followup.</strong>&nbsp;
                              Identifying issues with your data is only half the battle. It is equally important to take action when warnings are triggered. All Grant Recipients should have a system in place for reviewing and taking action in the face of a potential data reliability problem. 
                              <br/><br/>
                              Please discuss your plan to address this issue in the response box below.

                              <textarea  name="procsForReviewingResultsDesc"
                                    id="procsForReviewingResultsDesc" style={{width:"100%"}}
                                    value={state.Assessment4Model.procsForReviewingResultsDesc}
                                    onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent)}></textarea>
                              <br/>
                          </span>}
                      <br/>  
                  </li>
                </ol>
            </div>
        }

        {state.CurrentAssessementStepIndex == Assessment4StepsEnum.procsForAddingNewChecks &&
            <div>
                <p><strong><u>Question 7:</u>Adding Checks</strong></p>
                <ol start={7}>
                    <li>
                      Is there a system in place to add checks when new problems arise? 

                      <br/>
                      <label>
                          <input type="radio"
                              name="procsForAddingNewChecksFlag"
                              id="procsForAddingNewChecksFlag_true"
                              value="true"
                              checked={state.Assessment4Model.procsForAddingNewChecksFlag === true}
                              onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent)}
                          />
                          <span>Yes</span>
                      </label>
                      &nbsp;&nbsp;
                      <label>
                          <input type="radio"
                              name="procsForAddingNewChecksFlag"
                              id="procsForAddingNewChecksFlag_false"
                              value="false"
                              checked={state.Assessment4Model.procsForAddingNewChecksFlag === false}
                              onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent)}
                          />
                          <span>No</span>
                      </label>
                      <br/ >
                      {state.Assessment4Model.procsForAddingNewChecksFlag === true
                        && <span><strong>Good!</strong>
                            No action needed!

                        </span>}
                      {state.Assessment4Model.procsForAddingNewChecksFlag === false
                        && <span>
                              <strong>Requires followup.</strong>&nbsp;
                              The key to having reliable data is ensuring that your system is flexible and ready to adapt to new issues when they arise. All Grant Recipients should have a system in place to add new checks to their data routines in the face of unanticipated problems. 
                              <br/><br/>
                              Please discuss your plan to address this issue in the response box below.

                              <textarea  name="procsForAddingNewChecksDesc"
                                    id="procsForAddingNewChecksDesc" style={{width:"100%"}}
                                    value={state.Assessment4Model.procsForAddingNewChecksDesc}
                                    onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent)}></textarea>
                              <br/>
                          </span>}
                      <br/>  
                  </li>
                </ol>
            </div>
        }


        {state.CurrentAssessementStepIndex == Assessment4StepsEnum.procsForRemovingChecks &&
            <div>
                <p><strong><u>Question 8:</u>Removing/Adjusting Checks</strong></p>
                <ol start={8}>
                    <li>
                      Is there a system in place for removing checks that generate high false positive rates?
                      <br/>
                      <label>
                          <input type="radio"
                              name="procsForRemovingChecksFlag"
                              id="procsForRemovingChecksFlag_true"
                              value="true"
                              checked={state.Assessment4Model.procsForRemovingChecksFlag === true}
                              onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent)}
                          />
                          <span>Yes</span>
                      </label>
                      &nbsp;&nbsp;
                      <label>
                          <input type="radio"
                              name="procsForRemovingChecksFlag"
                              id="procsForRemovingChecksFlag_false"
                              value="false"
                              checked={state.Assessment4Model.procsForRemovingChecksFlag === false}
                              onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent)}
                          />
                          <span>No</span>
                      </label>
                      <br/ >
                      {state.Assessment4Model.procsForRemovingChecksFlag === true
                        && <span><strong>Good!</strong>
                            No action needed!

                        </span>}
                      {state.Assessment4Model.procsForRemovingChecksFlag === false
                        && <span>
                              <strong>Requires followup.</strong>&nbsp;
                              Checks with high false positive rates waste your and your staff’s time, as you will need to investigate each warning that check triggers. Grant Recipients should have a system in place for either revising or removing checks that do not function properly. 
                              <br/><br/>
                              Please discuss your plan to address this issue in the response box below.

                              <textarea  name="procsForRemovingChecksDesc"
                                    id="procsForRemovingChecksDesc" style={{width:"100%"}}
                                    value={state.Assessment4Model.procsForRemovingChecksDesc}
                                    onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent)}></textarea>
                              <br/>
                          </span>}
                      <br/>  
                  </li>
                </ol>
            </div>
        }


        {state.CurrentAssessementStepIndex == Assessment4StepsEnum.ActionPlanSummary &&
              <div>
                  <p>
                      <strong><u>Step 9:</u> Aggregated Action Plan </strong>
                  </p>
                  <p>
                      Congratulations! You have reached the end of Assessment #4. Your aggregated action plan for every
                      issue identified in Assessment #4 is included in the table below. You can now download or
                      print the Assessment #3 action plan below. Also, you can revisit this page at any time by
                      selecting it from the list of completed assessments on the Assessment Tool Selection Page. 
                  </p>
                  <table id="tblDataReliabilityActionPlan">
                      <thead>
                        <tr>
                            <th>Issue</th>
                            <th>Status</th>
                            <th>Action Plan</th>
                        </tr>
                      </thead>
                      <tbody>
                          <tr>
                              <td>
                                  Checking Routines for Household Account Numbers
                              </td>
                              <td>
                                  {state.Assessment4Model.checkAcctNumFlag?"Yes":"No"}
                              </td>
                              <td>
                                  {state.Assessment4Model.checkAcctNumDesc}
                              </td>
                          </tr>
                          <tr>
                              <td>
                                  Checking Routines for Missing Information in the Vendor System
                              </td>
                              <td>
                                  {state.Assessment4Model.checkVendorCantFindAcctFlag?"Yes":"No"}
                              </td>
                              <td>
                                  {state.Assessment4Model.checkVendorCantFindAcctDesc}
                              </td>
                          </tr>
                          <tr>
                              <td>
                                  Checking Percentage of Households with Data Received
                              </td>
                              <td>
                                  {state.Assessment4Model.checkShareHHDataReceivedEachVendorFlag?"Yes":"No"}
                              </td>
                              <td>
                                  {state.Assessment4Model.checkShareHHDataReceivedEachVendorDesc}
                              </td>
                          </tr>
                          <tr>
                              <td>
                                  Checking Data Against the SEDS
                              </td>
                              <td>
                                  {state.Assessment4Model.checkAvgHeatExpendVsSedsPerVendorFlag?"Yes":"No"}
                              </td>
                              <td>
                                  {state.Assessment4Model.checkAvgHeatExpendVsSedsPerVendorDesc}
                              </td>
                          </tr>
                          <tr>
                              <td>
                                  Checking for Outliers
                              </td>
                              <td>
                                  {state.Assessment4Model.checkRangeReptByVendorsFlag?"Yes":"No"}
                              </td>  
                              <td>
                                  {state.Assessment4Model.checkRangeReptByVendorsDesc}
                              </td>
                          </tr>
                          <tr>
                              <td>
                                  Taking Action in the Event of Failed Checks
                              </td>
                              <td>
                                  {state.Assessment4Model.procsForReviewingResultsFlag?"Yes":"No"}
                              </td>  
                              <td>
                                  {state.Assessment4Model.procsForReviewingResultsDesc}
                              </td>
                          </tr>
                          <tr>
                              <td>
                                  Adding Checks
                              </td>
                              <td>
                                  {state.Assessment4Model.procsForAddingNewChecksFlag?"Yes":"No"}
                              </td>  
                              <td>
                                  {state.Assessment4Model.procsForAddingNewChecksDesc}
                              </td>
                          </tr>
                          <tr>
                              <td>
                                  Removing/Adjusting Checks
                              </td>
                              <td>
                                  {state.Assessment4Model.procsForRemovingChecksFlag?"Yes":"No"}
                              </td>  
                              <td>
                                  {state.Assessment4Model.procsForRemovingChecksDesc}
                              </td>
                          </tr>
                      </tbody>
                  </table>
              </div>
        }
        <br /><br />      
        <button className="dataButton"
            onClick={() => state.assessment4ShowPreviousStep()}>
            Previous
        </button>
        {state.CurrentAssessementStepIndex < Assessment4StepsEnum.ActionPlanSummary
        &&
            <button className="dataButton"
                onClick={() => state.assessment4ShowNextStep()}
                disabled={state.Assessment4ShowNextStepDisabled === true}>
                Next
            </button>
        }

        {state.CurrentAssessementStepIndex < Assessment4StepsEnum.ActionPlanSummary
        &&
            <button className="dataButton"
                onClick={() => state.assessment4ShowActionPlan()}
                disabled={state.Assessment4ShowNextStepDisabled === true}>
                View Action Plan
            </button>
        }

        <br/>
        <button className="dataButton"
            onClick={() => state.backToStart()}>
            {state.CurrentAssessementStepIndex < Assessment4StepsEnum.ActionPlanSummary
              &&<React.Fragment>Back to start</React.Fragment>}
              {state.CurrentAssessementStepIndex === Assessment4StepsEnum.ActionPlanSummary
              &&<React.Fragment>Finish &amp; Save</React.Fragment>}
        </button>
        {state.CurrentAssessementStepIndex === Assessment4StepsEnum.ActionPlanSummary
        &&
            <button className="dataButton"
                onClick={() => window.print()}>
                Print
            </button>
        }
        {state.CurrentAssessementStepIndex == Assessment4StepsEnum.ActionPlanSummary
        &&
          <Assessment4DownloadCSV assessment4Model={state.Assessment4Model}/>
        }
    </div>
);

export default Assessment4;
